import { AfterViewInit, Component, OnInit } from '@angular/core';
export type AppTouchEvent = TouchEvent;

@Component({
    selector: 'app-signature-canvas',
    templateUrl: './signature-canvas.component.html',
    styleUrls: ['./signature-canvas.component.css'],
    standalone: true
})
export class SignatureCanvasComponent implements OnInit, AfterViewInit {

  // Properties
  private signatureCanvas: HTMLCanvasElement;
  private context: CanvasRenderingContext2D;
  private currX = 0;
  private currY = 0;
  private drawing = false;
  private isSafari = navigator.vendor.match(/apple/i) &&
    !navigator.userAgent.match(/crios/i) &&
    !navigator.userAgent.match(/fxios/i) &&
    !navigator.userAgent.match(/Opera|OPT\//);

  constructor() { }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    this.signatureCanvas = document.getElementById('SIGNATURE_CANVAS') as HTMLCanvasElement;
    this.context = this.signatureCanvas.getContext('2d');
    this.context.canvas.width = (document.getElementById('CANVAS_CONTAINER') as HTMLDivElement).clientWidth;
    this.context.canvas.height = 100;

     // Event Listeners (Mouse & Touch Support)
     this.signatureCanvas.addEventListener('pointerdown', (event) => this.startDrawing(event));
     this.signatureCanvas.addEventListener('pointermove', (event) => this.keepDrawing(event));

     // to stop drawing on pointer up outside the canvas
     document.addEventListener('pointerup', () => this.stopDrawing());
   }

   // Set Position
  private setPosition(event: PointerEvent): void {
    const canvasRect = this.signatureCanvas.getBoundingClientRect();
    this.currX = event.clientX - canvasRect.left;
    this.currY = event.clientY - canvasRect.top;

    // Safari Fix (optional)
    if (window.screen.availWidth < 1025 || !this.isSafari) {
      this.currX = event.clientX - canvasRect.left;
      this.currY = event.clientY - canvasRect.top;
    }
  }

   // Start Drawing
  private startDrawing(event: PointerEvent): void {
    this.drawing = true;
    this.setPosition(event);
  }

  // Keep Drawing
  private keepDrawing(event: PointerEvent): void {
    if (!this.drawing) return;
    this.context.beginPath();
    this.context.strokeStyle = 'black';
    this.context.lineWidth = 2;
    this.context.moveTo(this.currX, this.currY);
    this.setPosition(event);
    this.context.lineTo(this.currX, this.currY);
    this.context.stroke();
    this.context.closePath();
  }

  // Stop Drawing
  private stopDrawing(): void {
    this.drawing = false;
  }

  // Erase Canvas
  eraseCanvas(): void {
    this.context.clearRect(0, 0, this.signatureCanvas.width, this.signatureCanvas.height);
  }
}
